import React from "react";
import MicrophoneButton from "../Buttons/MicrophoneButton";
import CameraButton from "../Buttons/CameraButton";
import SkipThisQuestionButton from "../Buttons/SkipThisQuestionButton";
import { useCamera } from "src/contexts/CameraContext";

interface InterviewControlsProps {
    onCameraToggle: () => void;
    onMicrophoneClick: () => void;
    onSkipQuestion: () => void;
    isActive: boolean; // Controls are active when interviewer isn't speaking
    isTutorial?: boolean;
}

const InterviewControls: React.FC<InterviewControlsProps> = ({
    onCameraToggle,
    onMicrophoneClick,
    onSkipQuestion,
    isActive,
    isTutorial,
}) => {
    const { cameraActive, hasPermission, toggleCamera, isInitialized } =
        useCamera();

    // Handle camera button click with additional safety
    const handleCameraClick = () => {
        console.log(
            "Camera button clicked from controls, current state:",
            cameraActive
        );
        console.log("Is camera initialized:", isInitialized);

        // Only toggle if the camera is initialized
        if (isInitialized) {
            toggleCamera();
        } else {
            console.warn("Camera not initialized yet, ignoring toggle");
        }
    };

    return (
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex gap-4">
            <CameraButton
                isActive={cameraActive && hasPermission}
                onClick={handleCameraClick}
            />
            <MicrophoneButton
                isActive={isActive}
                onClick={onMicrophoneClick}
                isTutorial={isTutorial}
            />
            <SkipThisQuestionButton
                isActive={isActive}
                onClick={onSkipQuestion}
            />
        </div>
    );
};

export default InterviewControls;
